import { styled, Card } from '@mui/material';

export const CardType = styled(Card)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '2em',
  borderRadius: '1rem',
  color: '#FFFFFF',
  minHeight: '100%',
});
